import React from 'react'
import PropTypes from 'prop-types'

import strings from 'utils/strings.js'
import { CHECPLUS_MODULE_TYPES } from 'utils/constants'

import { RadioButtonGroup } from 'components/patterns'
import BitGrid from 'components/feature/NavigatorPanes/editors/base/BitGrid'
import CanOutputSection from '../CanOutputSection'
import { CanOutputContainer } from './OutputCanEditor.style'

const OutputCanEditor = ({
  featureModuleType,
  numberOfBits,
  startBit,
  updateNumberOfBits,
  updateStartBit,
  disabledBits,
  featureModuleName,
  mappedOutputId,
}) => {
  // If we have an output query mapped to a 16-bit CAN output, we must disable 2-bit.
  const bitButtons = [
    {
      value: 2,
      disabled: featureModuleType === CHECPLUS_MODULE_TYPES.ASAM,
    },
    { value: 16, disabled: false },
  ]

  return (
    <>
      <CanOutputContainer>
        <RadioButtonGroup
          vertical
          name="number_of_bits"
          label={strings.number_of_bits}
          onChange={updateNumberOfBits}
          currentValue={numberOfBits}
          buttonStyle="solid"
          buttons={bitButtons}
          radioGroupClassName="number-of-bits-radio-group"
        />
        <CanOutputSection
          numberOfBits={numberOfBits}
          mappedOutputId={mappedOutputId}
          showCanId={true}
        />
      </CanOutputContainer>

      <BitGrid
        type="output"
        groupSize={numberOfBits}
        value={startBit}
        selectionHandler={updateStartBit}
        disabledBits={disabledBits}
        featureModuleName={featureModuleName}
      />
    </>
  )
}

OutputCanEditor.propTypes = {
  featureModuleType: PropTypes.string,
  numberOfBits: PropTypes.number,
  startBit: PropTypes.number,
  updateNumberOfBits: PropTypes.func,
  updateStartBit: PropTypes.func,
  disabledBits: PropTypes.array,
  setSelectedOutput: PropTypes.func,
  mappedOutputId: PropTypes.string,
  disableSixteenBit: PropTypes.bool,
  featureModuleName: PropTypes.string,
}

export default OutputCanEditor
